import { createAsyncThunk } from "@reduxjs/toolkit";
import { ThunkApiConfig } from "@shared/models/redux";
import { ContactResponse } from "@myProfile/models";

export const fetchContactInformationThunk = createAsyncThunk<ContactResponse, string, ThunkApiConfig>(
  "myProfile/fetchContactInformation",
  async (contactId, { extra, rejectWithValue }) => {
    try {
      const url = `contacts/v1/system/SnowflakeData/contact/${contactId}`;
      const response = await extra<ContactResponse>(
        url,
        {
          method: "GET",
        },
        { includeUserId: false, includeAccountGroupId: false }
      );

      if (!response || !response.data) {
        return rejectWithValue("Failed to fetch contact information");
      }

      return response.data;
    } catch (error) {
      console.error("[Contact Information API] Error fetching data:", error);

      return rejectWithValue("Failed to fetch contact information");
    }
  }
);
